import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { Header, Loader } from 'components'

const Login = React.lazy(() => import('pages/unauthenticated/Login'))
const RequestAccess = React.lazy(() => import('pages/unauthenticated/RequestAccess'))

export const UnauthenticatedApp: React.FC = () => {
  return (
    <div data-testid="unauthenticated-app">
      <Header />

      <Switch>
        <Route path="/login" exact>
          <React.Suspense fallback={<Loader />}>
            <Login />
          </React.Suspense>
        </Route>
        <Route path="/request-access" exact>
          <React.Suspense fallback={<Loader />}>
            <RequestAccess />
          </React.Suspense>
        </Route>

        <Redirect from="/" to="/login" />
      </Switch>
    </div>
  )
}
